<script>

</script>

<template>
  <div class="fixed bottom-10 right-10 z-50 shadow-lg rounded-full">
    <a
      href="https://api.whatsapp.com/send?phone=628115546000&text=Permisi Tim Baznas, saya izin bertanya"
      class="
        bg-hijau
        text-white
        hover:bg-hijau
        transition-all
        duration-150
        w-16
        h-16
        rounded-full
        flex
        justify-center
        items-center
      "
    >
      <i class="fab fa-whatsapp text-3xl"></i>
    </a>
  </div>
</template>